<template>
  <FaceMenuTag :model="model">
    <div
      ref="container"
      slot-scope="{ addTag, removeTag, isSelected }"
      class="flex items-baseline"
    >
      <component
        :is="model.indexed ? 'a' : 'span'"
        class="px-4 cursor-pointer py-1 border inline-flex whitespace-no-wrap items-center text-xs text-blue-dark rounded"
        :href="model.indexed ? model.url : null"
        :class="{
          'bg-blue-dark text-white ltr:pr-0 rtl:pl-0': isSelected
        }"
        :style="{
          'pointer-events': disabled ? 'none' : null,
          'opacity-50': disabled
        }"
        :disabled="disabled"
        @click.prevent="addTag"
      >
        {{ model.name }}
        <span
          v-if="isSelected"
          class="inline-flex items-center justify-center w-8 h-5"
          @click.stop.prevent="removeTag"
        >
          <IconCross
            width="12px"
            height="12px"
            stroke="white"
          />
        </span>
      </component>
      <button
        v-if="model.children.length"
        class="text-blue-dark inline-flex items-center text-2xs ltr:ml-3 rtl:mr-3"
        :class="{
          'is-opened': isOpened
        }"
        @click="toggleChildren"
      >
        <template v-if="isOpened">
          <span class="underline">
            {{ store.state.translations.showLessText }}
          </span>
          <span class="transform rotate-180 icon-chevron-down text-3xs scale-75 ml-1" />
        </template>
        <template v-else>
          <span class="underline">
            {{ store.state.translations.showMoreText }}
          </span>
          <span class="icon-chevron-down text-3xs transform scale-75 ml-1" />
        </template>
      </button>
    </div>
  </FaceMenuTag>
</template>

<script>
import IconCross from '@/assets/icons/icon-cross.svg'
import store from '@/components/facet/store'
import FaceMenuTag from '@/components/facet/FacetTagMenuTag.vue'
// import tracking from '@/CVI/Facet/lib/tracking'


export default {
  components: {
    IconCross,
    FaceMenuTag
  },
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      store,
      isOpened: false
    }
  },
  computed: {
    disabled() {
      const { children } = this.model
      if (!children.length) {
        return false
      }

      const { tags } = this.store.state
      const tagUids = tags.map((tag) => tag.uid)
      const childrenTagUids = children.map((tag) => tag.uid)

      return tagUids.filter((uid) => childrenTagUids.includes(uid)).length > 0
    }
  },
  methods: {
    toggleChildren() {
      this.isOpened = !this.isOpened
      const childrenContainer = this.$refs.container.nextElementSibling

      if (this.isOpened) {
        // tracking.expandSubMenu(this.model.name)
        childrenContainer.classList.add('is-opened')
      } else {
        childrenContainer.classList.remove('is-opened')
      }
    }
  }
}
</script>
